/**
 * Organic Score Color System
 * 4-level color coding with matte, natural tones
 * Distinct from pillar colors (Terracotta Nights palette)
 */

export interface ScoreStyle {
  // Hex color for the solid badge background
  hex: string;
  // RGBA fill with 15% opacity for radar chart
  fill: string;
  // Stroke color for radar chart line
  stroke: string;
  // Tailwind classes for badge (solid background)
  badgeClass: string;
}

/**
 * Get score colors based on the 4-level organic system
 * - 85-100: Deep Forest Green (#2F6A38) - Excellent
 * - 66-84: Olive Green (#7E8F35) - Good
 * - 50-65: Amber Orange (#E8943D) - Passable
 * - <50: Brick Red (#A83232) - Poor
 */
export const getScoreColors = (score: number): ScoreStyle => {
  if (score >= 85) {
    return {
      hex: '#1B5E20',
      fill: 'rgba(27, 94, 32, 0.15)',
      stroke: '#1B5E20',
      badgeClass: 'bg-[#1B5E20]',
    };
  }
  if (score >= 65) {
    return {
      hex: '#4E7E6A',
      fill: 'rgba(78, 126, 106, 0.15)',
      stroke: '#4E7E6A',
      badgeClass: 'bg-[#4E7E6A]',
    };
  }
  if (score >= 50) {
    return {
      hex: '#E8943D',
      fill: 'rgba(232, 148, 61, 0.15)',
      stroke: '#E8943D',
      badgeClass: 'bg-[#E8943D]',
    };
  }
  return {
    hex: '#A83232',
    fill: 'rgba(168, 50, 50, 0.15)',
    stroke: '#A83232',
    badgeClass: 'bg-[#A83232]',
  };
};

/**
 * Get score label based on the 4-level system
 */
export const getScoreLabel = (score: number, language: 'fr' | 'en' = 'fr'): string => {
  if (score >= 85) {
    return language === 'fr' ? 'Exemplaire' : 'Exemplary';
  }
  if (score >= 65) {
    return language === 'fr' ? 'Sérieux' : 'Serious';
  }
  if (score >= 50) {
    return language === 'fr' ? 'Insuffisant' : 'Insufficient';
  }
  return language === 'fr' ? 'Alerte' : 'Alert';
};
